import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, signal } from '@angular/core';
import { MusicDataService } from '../music-data.service';
import { FavouriteArtistsService } from '../favourite-artists.service';
import { FavouriteHeartComponent } from '../shared/favourite-heart.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { FlexModule } from '@ngbracket/ngx-layout/flex';

import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardImage, MatCardContent } from '@angular/material/card';

import { CommonModule } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css'],
  imports: [CommonModule, FlexModule, MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardImage, RouterLink, MatCardContent, FavouriteHeartComponent]
})
export class SearchResultComponent implements OnInit, OnDestroy {
  results = signal<any[]>([]);
  searchQuery = signal('');
  private qSub: Subscription;
  private searchSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private data: MusicDataService,
    protected artistFavourites: FavouriteArtistsService
  ) { }

  ngOnInit() {
    this.artistFavourites.ensureIds();
    this.qSub = this.route.params.subscribe(params => {
      this.searchQuery.set(params['id']);
      this.searchSub = this.data.searchArtists(this.searchQuery()).subscribe({
        next: (d) => {
          if (d && d.artists && d.artists.items) {
            this.results.set(d.artists.items.filter(item => item.images.length > 0));
          } else {
            console.error('Unexpected response format:', d);
          }
        },
        error: (err) => {
          console.error('Search error:', err);
          // Optionally: Display user-friendly error message here
        }
      });
    });
  }

  ngOnDestroy() {
    this.qSub?.unsubscribe();
    this.searchSub?.unsubscribe();
  }
}
